import React from 'react';
import { Item } from '../../components/common';
import styled from 'styled-components';
import { mapWithIndex, getFilteredItemsByHashTags } from '../../utils';


export default ({ filter, setModal, setStartupIndex }) => {
  const items = getFilteredItemsByHashTags(filter)

  return (
    <StyledListContainer>
      {mapWithIndex((projectId, index) => (
        <Item
          key={projectId}
          setModal={setModal}
          projectId={projectId}
          index={index}
          setStartupIndex={setStartupIndex}
        />
      ))(items)}
    </StyledListContainer>
  );
}


const StyledListContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  grid-gap: 48px;
`;
